import { Fragment, useEffect, useState } from "react";
import Swal from "sweetalert2";
import { useUserContext } from "../../context/UserContext";
import { useNavigate } from "react-router-dom";

const Menu = ({ linksArray, DashboardsArray, DefaultArray }) => {
  const [open, setOpen] = useState(false);

  const toggleMenu = () => setOpen(!open);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!document.getElementById("inininin").contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div id="inininin">
      <Panel
        open={open}
        links={linksArray}
        Dashboards={DashboardsArray}
        DefaultArray={DefaultArray}
      />
      <Button toggle={toggleMenu} open={open} />
    </div>
  );
};

const Button = ({ toggle, open }) => {
  return (
    <div id="nav-icon1" className={open ? " open" : ""} onClick={toggle}>
      <span></span>
      <span></span>
      <span></span>
    </div>
  );
};

const Panel = ({ open, links, Dashboards, DefaultArray }) => {
  return (
    <div
      className={
        open
          ? "absolute top-0 right-0 menu-wrapper menu-open"
          : "absolute top-0 right-0 menu-wrapper invisible"
      }
    >
      <Links
        links={links}
        open={open}
        Dashboards={Dashboards}
        DefaultArray={DefaultArray}
      />
    </div>
  );
};

const Links = ({ links, open, Dashboards, DefaultArray }) => {
  const { setUserData } = useUserContext();

  const navigate = useNavigate();

  const old_access_token = localStorage.getItem("old_access_token");

  const logOut = () => {
    Swal.fire({
      title: "آیا مطمئن هستید که می خواهید از حساب خود خارج شوید؟",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#477CD1",
      cancelButtonColor: "white",
      confirmButtonText: "بله",
      cancelButtonText: "خیر",
      customClass: {
        confirmButton: "my-confirm-button",
        cancelButton: "my-cancel-button",
        icon: "no-border",
        title: "title-padding",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        if (!old_access_token) {
          localStorage.clear();
          document.cookie.split(";").forEach((cookie) => {
            const name = cookie.split("=")[0].trim();
            document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
          });
          setUserData(null);
          Swal.fire({
            title: "از حساب کاربری خود خارج شدید",
            icon: "success",
            showConfirmButton: false,
            timer: 2000,
          });
          navigate("/");
        } else {
          old_access_token &&
            localStorage.setItem("access_token", old_access_token);

          localStorage.removeItem("old_access_token");
          navigate("/fa/admin-dashboard");
        }
      }
    });
  };

  const linkList = links?.map((link, index) => (
    <li key={index} className="link hover:bg-primary-100 rounded-lg">
      <a
        className="text-gray-500 hover:text-gray-900 hover:font-bold"
        href={link.url}
      >
        {link.name}
      </a>
    </li>
  ));

  const DashboardItems = Dashboards?.map((Dashboard, index) => (
    <li
      key={index}
      className="flex items-center text-gray-500 hover:bg-primary-100 rounded-lg gap-1"
    >
      <a
        className="flex text-gray-500 hover:text-gray-900 hover:font-bold"
        href={Dashboard.url}
      >
        {Dashboard?.icon && Dashboard.icon}&ensp;
        {Dashboard.name}
      </a>
    </li>
  ));

  const DefaultItems = DefaultArray?.map((DefaultArrays, index) => (
    <Fragment key={index}>
      {DefaultArrays.url !== "#" ? (
        <li
          key={index}
          className="flex items-center text-gray-500 hover:bg-primary-100 rounded-lg gap-1"
        >
          <a
            className="flex text-gray-500 hover:text-gray-900 hover:font-bold"
            href={DefaultArrays.url}
          >
            {DefaultArrays?.icon && DefaultArrays.icon}&ensp;
            {DefaultArrays.name}
          </a>
        </li>
      ) : (
        <li
          onClick={() => logOut()}
          key={index}
          className="text-red-500 flex items-center gap-1 hover:bg-red-100 rounded-lg"
        >
          <p className="flex text-red-500 cursor-pointer hover:font-bold">
            {DefaultArrays?.icon && DefaultArrays.icon} &ensp;
            {DefaultArrays.name}
          </p>
        </li>
      )}
    </Fragment>
  ));

  return (
    <div
      className={
        open
          ? "links-wrapper flex flex-col"
          : "links-wrapper flex-col links-wrapper-closed hidden"
      }
    >
      <img
        src="/images/logovam30svg.svg"
        className="w-full px-10 cursor-pointer"
        onClick={() => navigate("/")}
        alt="Flowbite Logo"
      />
      <ul className="link-list border-b border-primary-600">{linkList}</ul>
      <ul className="link-list border-b border-primary-600">
        {DashboardItems}
      </ul>
      <ul className="link-list ">{DefaultItems}</ul>
    </div>
  );
};

export default Menu;
